import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './slices/store'; // ⚠️ Importer depuis store.ts, pas index.ts

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAuth = () => {
  const { user, loading, error } = useAppSelector((state) => state.authentification);
  return {
    user,
    loading,
    error,
    isAuthenticated: Boolean(user?.isConnected && user?.token && user?.id),
    userId: user?.id || null,
    userToken: user?.token || null,
    userEmail: user?.email || null,
  };
};

export const useLeases = () => {
  const leases = useAppSelector((state) => state.lease?.leases || []);
  const loading = useAppSelector((state) => state.lease?.loading || false);
  const error = useAppSelector((state) => state.lease?.error || null);
  //const currentLease = useAppSelector((state) => state.lease?.currentLease || null);
  return { leases, loading, error,  hasLeases: leases.length > 0 };
};

export const useTenants = () => {
  const tenants = useAppSelector((state) => state.tenant?.tenants || []);
  const loading = useAppSelector((state) => state.tenant?.loading || false);
  const error = useAppSelector((state) => state.tenant?.error || null);
  return { tenants, loading, error, hasTenants: tenants.length > 0 };
};

export const useLocals = () => {
  const locals = useAppSelector((state) => state.local?.locals || []);
  const loading = useAppSelector((state) => state.local?.loading || false);
  const error = useAppSelector((state) => state.local?.error || null);
  return { locals, loading, error, hasLocals: locals.length > 0 };
};

export const usePayments = () => {
  const payments = useAppSelector((state) => state.payment?.payments || []);
  const loading = useAppSelector((state) => state.payment?.loading || false);
  const error = useAppSelector((state) => state.payment?.error || null);
  return { payments, loading, error, hasPayments: payments.length > 0 };
};

export const useTodos = () => {
  const todos = useAppSelector((state) => state.todo?.todos || []);
  const loading = useAppSelector((state) => state.todo?.loading || false);
  const error = useAppSelector((state) => state.todo?.error || null);
  return { todos, loading, error, hasTodos: todos.length > 0 };
};

export const useDebugStore = () => {
  const fullState = useAppSelector((state) => state);
  if (process.env.NODE_ENV === 'development') {
    console.log('🐛 Full Store State:', fullState);
  }
  return fullState;
};